import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType } from '@/lib/react-query';
import getApi from '@/lib/axios';

async function get_entrada_dia_a_dia(params): Promise<any> {
  const api = await getApi();
  const { data } = await api.get<any>('/fluxo_caixa/entrada_por_dia/', {params});
  return data;
}

type QueryFnType = typeof get_entrada_dia_a_dia;

function useFluxoCaixaEntradaDiaADia(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['get_entrada_por_dia', params.year, params.month],
    queryFn: () => get_entrada_dia_a_dia(params),
  });
}

export { useFluxoCaixaEntradaDiaADia };
